{
  "Clear search": "Tühjenda otsing"
}